import { render, staticRenderFns } from "./UDIrukuDialog.vue?vue&type=template&id=05a9849d&scoped=true"
import script from "./UDIrukuDialog.vue?vue&type=script&lang=js"
export * from "./UDIrukuDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a9849d",
  null
  
)

export default component.exports